export default __webpack_public_path__ + "static/media/graph-billing.5619b1ad.svg";